import classNames from 'clsx';
import styles from '../../embed.style';
import type { VideoEmbedADT } from '../../type';
import { getYoutubeId } from '../../utils/getYoutubeId';

export function youtube(input: VideoEmbedADT): VideoEmbedADT {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host === 'youtube.com' || host === 'youtu.be' || host === 'www.youtube.com') {
    const youtubeId = getYoutubeId(input.href);
    if (!youtubeId) return input;
    return (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          frameBorder="0"
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${youtubeId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  return input;
}
